module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921074151_T.353ad0f5.jpg";